/* Refresh saved/compared products in the visitor's current market and locale.
   Stored titles and images are never authority for market presentation. */
(() => {
  const config = document.querySelector('[data-dss-market-context]');
  if (!config || config.dataset.enabled !== 'true') return;
  const { market, locale, root } = config.dataset;
  const productPath = /^\/products\/([a-z0-9-]+)$/;
  async function read(paths, signal) {
    const handles = paths.map(path => productPath.exec(path)?.[1]);
    if (handles.some(handle => !handle) || new Set(handles).size !== handles.length || !root?.startsWith('/') || root.startsWith('//')) throw new Error(window.FivePointI18n.t("Invalid product reference"));
    const url = new URL(root.replace(/\/$/, '') + '/search', location.origin);
    if (url.origin !== location.origin) throw new Error(window.FivePointI18n.t("Invalid storefront origin"));
    url.searchParams.set('section_id', 'dss-market-products');
    url.searchParams.set('q', handles.join('|'));
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
    if (!response.ok) throw new Error(window.FivePointI18n.t("Product content could not be refreshed"));
    const html = await response.text();
    if (html.length > 1048576) throw new Error(window.FivePointI18n.t("Invalid product response"));
    const document = new DOMParser().parseFromString(html, 'text/html');
    const batch = document.querySelector('[data-dss-market-batch]');
    if (!batch || batch.dataset.market !== market || batch.dataset.locale !== locale) throw new Error(window.FivePointI18n.t("Product context changed"));
    const payloads = batch.querySelectorAll('[data-dss-market-card]');
    if (payloads.length !== handles.length) throw new Error(window.FivePointI18n.t("Missing product content"));
    const products = new Map();
    for (const payload of payloads) {
    const value = JSON.parse(payload.textContent);
    if (value.schema !== 1 || value.market !== market || value.locale !== locale || !handles.includes(value.handle) || products.has(value.handle) || typeof value.available !== 'boolean' || ['title', 'image', 'composition', 'weight', 'width'].some(key => typeof value[key] !== 'string')) throw new Error(window.FivePointI18n.t("Product context changed"));
    const path = '/products/' + value.handle;
    products.set(value.handle, presentation(value, path));
    }
    return handles.map(handle => products.get(handle));
  }
  function presentation(value, path) {
    if (!value.available) return { url: path, available: false, title: window.FivePointI18n.t("Unavailable in this market"), image: '', composition: '', weight: '', width: '' };
    if (!value.title || !value.image) throw new Error(window.FivePointI18n.t("Incomplete market content"));
    const image = new URL(value.image, location.origin);
    if (image.protocol !== 'https:' || (image.hostname !== 'cdn.shopify.com' && image.origin !== location.origin)) throw new Error(window.FivePointI18n.t("Invalid product image"));
    return { url: path, available: true, title: value.title, image: image.href, composition: value.composition, weight: value.weight, width: value.width };
  }
  async function resolve(items, signal) {
    if (!Array.isArray(items) || items.length > 200) throw new Error(window.FivePointI18n.t("Invalid saved list"));
    const output = new Array(items.length);
    let next = 0;
    const groups = [];
    for (let i = 0; i < items.length; i += 20) groups.push(items.slice(i, i + 20));
    const batch = new AbortController();
    // One section request per twenty products; at most four batches in flight.
    try { await Promise.all(Array.from({ length: Math.min(4, groups.length) }, async () => {
      while (next < groups.length) {
        if (batch.signal.aborted || signal?.aborted) throw new DOMException('Aborted', 'AbortError');
        const index = next++;
        const timeout = AbortSignal.timeout(10000);
        const values = await read(groups[index].map(item => item.url), AbortSignal.any([batch.signal, timeout, ...(signal ? [signal] : [])]));
        values.forEach((value, offset) => { output[index * 20 + offset] = value; });
      }
    })); } catch (error) { batch.abort(); throw error; }
    return output;
  }
  window.DSSMarketPresentation = Object.freeze({ resolve });
})();
